import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"

const IndexPage = () => {
    return (
        <Layout>
            <h2>Welcome</h2>
            <div className ="text-grid-1">
            <p>This is Mark Webster's personal website. I'm a computational graphic designer, writing code to craft engaging visual works that range from websites to interactive art installations.
            To learn more about me and my work, please read my <Link to="/about">about page.</Link></p>
            </div>
        </Layout>
    )
}

export default IndexPage